export const CONTENTFUL_SECTION_SW_PRICING_CONTENT = 'ContentfulSectionSwPricingContent';

export { default } from './SWPricingContent';
